import { ChangeDetectionStrategy, Component } from '@angular/core';
// Deliberately IonicModule, not `IonSkeletonText` from '@ionic/angular/standalone'. This component
// is eager, and that entrypoint pulls in a second Ionic copy which claims every ion-* custom
// element but never gets initialised — leaving mode-keyed components (ion-button, ion-card, ...)
// with an empty stylesheet, i.e. unstyled app-wide, silently. Switch only once the app migrates
// IonicModule.forRoot() → provideIonicAngular(); mixing the two entrypoints is unsupported.
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'c-document-skeleton',
  imports: [IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="document-skeleton">
      <div class="document-skeleton__page">
        <ion-skeleton-text [animated]="true" class="document-skeleton__title" />

        @for (paragraph of paragraphs; track $index) {
          <div class="document-skeleton__paragraph">
            @for (line of paragraph; track $index) {
              <ion-skeleton-text [animated]="true" class="document-skeleton__line" [style.width]="line" />
            }
          </div>
        }
      </div>

      <div class="document-skeleton__page document-skeleton__page--peek">
        <ion-skeleton-text [animated]="true" class="document-skeleton__title" />
      </div>
    </div>
  `,
  styles: `
    :host {
      display: block;
      height: 100%;
    }

    .document-skeleton {
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--spacing-xl);
      padding: var(--spacing-xl);
      background: #f9fafb;

      .document-skeleton__page {
        flex: 1 1 auto;
        min-height: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--spacing-xl);
        padding: var(--spacing-3xl);
        background: var(--surface-primary, #ffffff);
        border-radius: var(--radius-xl);
        box-shadow:
          0 0 0 0.5px rgba(46, 58, 81, 0.1),
          0 3px 6px -2px rgba(46, 58, 81, 0.1);

        .document-skeleton__page--peek {
          flex: 0 0 auto;
          height: 48px;
          overflow: hidden;
        }
      }

      .document-skeleton__title {
        width: 55%;
        height: 20px;
        margin: 0;
        border-radius: var(--radius-md);
      }

      .document-skeleton__paragraph {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-md);
      }

      .document-skeleton__line {
        height: 10px;
        margin: 0;
        border-radius: var(--radius-rounded);
      }
    }
  `,
})
export class DocumentSkeletonComponent {
  // Paragraphs of fake text lines; each string is a line width.
  readonly paragraphs: string[][] = [
    ['96%', '100%', '92%', '78%'],
    ['100%', '88%', '95%', '70%'],
    ['92%', '100%', '84%'],
  ];
}
